export const version = "4.1.6";
export const build = "esm";
//# sourceMappingURL=version.js.map
